// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <h2>“These aren’t just journals. They’re emotional lifelines.”</h2>

      <nav
        aria-label="Helpful links"
        style={{
          display: "flex",
          gap: 16,
          justifyContent: "center",
          flexWrap: "wrap",
          margin: "12px 0 6px",
        }}
      >
        <Link
          to="/settings"
          style={{ fontWeight: 700, color: "#6a0dad", textDecoration: "none" }}
        >
          Notifications
        </Link>

        <Link to="/privacy" style={{ color: "#6a0dad", textDecoration: "none" }}>
          Privacy
        </Link>

        <Link to="/terms" style={{ color: "#6a0dad", textDecoration: "none" }}>
          Terms
        </Link>

        <a
          href="mailto:whisperwallstudios@gmail.com"
          style={{ color: "inherit", textDecoration: "none" }}
        >
          Contact
        </a>
      </nav>

      <p className="email" style={{ marginTop: 6 }}>
        📧{" "}
        <a href="mailto:whisperwallstudios@gmail.com">
          whisperwallstudios@gmail.com
        </a>
      </p>

      <p className="copyright">© {year} WhisperWall. All rights reserved.</p>
    </footer>
  );
}
